/* import __COLOCATED_TEMPLATE__ from './title-text-image.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();